export default defineNuxtPlugin((nuxtApp) => {
  // nuxtApp.hook('render:html', (url, result) => {
  //   console.log('render:html', url, result)
  // })
  // nuxtApp.hook('app:rendered', (url, result) => {
  //   console.log('app:rendered', url, result)
  // })
  // nuxtApp.hook('render:island', (url, result) => {
  //   console.log('render:island', url, result)
  // })
  // nuxtApp.hook('render:response', (url, result) => {
  //   console.log('render:response', url, result)
  // })
  // nuxtApp.hook('app:rendered', (url, result) => {
  // })
  // 设置一个 page:start 钩子函数，当导航进入一个页面，并处于 Suspense 等待时调用
  // nuxtApp.hook('page:start', () => {
  // })
})
